import { Constants } from '../_constants/shared.constants';
const initialState = {};
function userProfileInfoReducer(state = initialState, action) {
  switch (action.type) {
    case Constants.userProfileInfo.USER_PROFILE_INFO:
      return {
        ...state,
        data: action.data,
      };
    default:
      return state
  }
}
export default userProfileInfoReducer;